{
  "name": "12-Harmonic Partials (fundamental = A)",
  "description": "12-tone 19-Limit Rational Intonation (JI) scale. Derived from the harmonic partial row, it is limited to partials 12°-25° over A, skipping 23°.",
  "scale": [
    "25/24",
    "13/12",
    "7/6",
    "5/4",
    "4/3",
    "17/12",
    "3/2",
    "19/12",
    "5/3",
    "7/4",
    "11/6",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HS_A13-26no23",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["E", "E", "F", "G", "G", "A", "A", "B", "C", "C", "D", "D"],
  "note_colors": [
    "#ffa0a0",
    "#fef5be",
    "#e6d7fe",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#d6f7ff",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 5,
  "center_degree": 5,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
